<template>
  <Article />
</template>
<script>
import Article from '@/components/common/layout/Article.vue'
export default {
  name: 'EmptyLayoutContainer',
  components: {
    Article,
  },
}
</script>
